<script>
export default
{
    name: 'separator',

    props:
    {
        excess: { type: String }
    },

    created ()
    {
    },

    render () 
    {
        var style = {}

        if (this.excess)
        {
            style = { width: `calc(100% + ${this.excess})`, marginLeft: `calc(${this.excess} / -2)` }
        }

        return (
            <div style={style} class='separator' />
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        onClick ()
        {
            this.$router.push({ path: this.path, append: true })
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.separator
{
    border-top: 1px solid var(--theme-border-color);
}
</style>


// WEBPACK FOOTER //
// src/components/Separator.vue